/*
 * Site: {SITE}
 * File: custom/forms
 * ============================================================================
 * Some description...
 * ============================================================================
 * Built by Xanthe Studios | xanthestudios.co.uk
 * ============================================================================
 */

/**
 * Some description...
 */

$('.c-form--enquiries').submit(function(e) {

	// Prevent default
	e.preventDefault();


	// Handle form submission
	const form    = $('.c-form--enquiries');
	const data    = form.serialize();
	const captcha = $('input[name=honeypot]').val();

	if (captcha !== '') {
		$('.c-alert--success').css('display', 'flex').hide().fadeIn();
		form.trigger('reset');
		return;
	}

	$.post('/wheelform/message/send',
		data,
		function(response) {

			if (response.success) {
				$('.c-alert--success').css('display', 'flex').hide().fadeIn();
				form.trigger('reset');
			} else {
				$('.c-alert--error').css('display', 'flex').hide().fadeIn();
			}

		}
	);

});





/**
 * Some description...
 */

$('.c-form--subscriptions').submit(function(e) {

	// Prevent default
	e.preventDefault();


	// Handle form submission
	const form    = $('.c-form--subscriptions');
	const data    = form.serialize();
	const captcha = $('input[name=honeypot]').val();

	if (captcha !== '') {
		$('.c-alert--success').css('display', 'flex').hide().fadeIn();
		form.trigger('reset');
		return;
	}

	$.post('/wheelform/message/send',
		data,
		function(response) {

			if (response.success) {
				$('.c-alert--success').css('display', 'flex').hide().fadeIn();
				form.trigger('reset');
			} else {
				$('.c-alert--error').css('display', 'flex').hide().fadeIn();
			}

		}
	);

});





/**
 * Some description...
 */

$('.c-form--unsubscribes').submit(function(e) {

	// Prevent default
	e.preventDefault();


	// Handle form submission
	const form    = $('.c-form--unsubscribes');
	const data    = form.serialize();
	const captcha = $('input[name=honeypot]').val();

	if (captcha !== '') {
		$('.c-alert--success').css('display', 'flex').hide().fadeIn();
		form.trigger('reset');
		return;
	}

	$.post('/wheelform/message/send',
		data,
		function(response) {

			if (response.success) {
				$('.c-alert--success').css('display', 'flex').hide().fadeIn();
				form.trigger('reset');
			} else {
				$('.c-alert--error').css('display', 'flex').hide().fadeIn();
			}

		}
	);

});
